import { downloadPrizesApi } from '../model/downloadsPrizesApi';
import { IDownloadPrizes } from '../types';

const getDownloadPrizeApi = downloadPrizesApi.injectEndpoints({
  endpoints: (builder) => ({
    getDownloadsPrize: builder.mutation<IDownloadPrizes, any>({
      query: ({ upload_type, size, page }) => {
        const sizeParams = size ? `&size=${size}` : '';
        const pageParams = page ? `page=${page}` : '';
        return {
          url: `/shop/admin/v1/uploads/${upload_type}/?${pageParams}${sizeParams}`,
          method: 'GET',
        };
      },
    }),
  }),
});

export const { useGetDownloadsPrizeMutation } = getDownloadPrizeApi;
